<template>
  <AppHeader>Old Dealer Transactions</AppHeader>

  <FromToDate @filter="getData"></FromToDate>

  <Loading v-if="state == 'loading'"></Loading>

  <div v-if="state == 'idle'" class="p-4">
    <div v-if="data.length != 0">
      <SearchSort
        ref="search"
        :defaults="{q: '', search: '-', sort: 'id', order: 'asc', group: '-'}"
        :sorts="{id: 'Transaction ID', amount: 'Amount', type: 'Type', purpose: 'Purpose'}"
        :columns="{id: 'Transaction ID', date: 'Date', amount: 'Amount', type: 'Type', purpose: 'Purpose'}"
        :groups="[]"
        @update="searchUpdated">
      </SearchSort>

      <div class="mt-4 responsive-table">
        <table>
          <thead>
            <tr>
              <th>ID</th>
              <th>Date</th>
              <th>Amount</th>
              <th>Closing</th>
              <th>Purpose</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="tnx in filteredData" :key="tnx.id" :class="{'bg-red-300': tnx.type == 'debit', 'bg-green-300': tnx.type == 'credit'}">
              <td><small>#{{ tnx.id }}</small></td>
              <td>{{ toDate(tnx.date) }}</td>
              <td><b>{{ toInr(tnx.amount) }}</b></td>
              <td><b>{{ toInr(tnx.closing_balance) }}</b></td>
              <td>{{ tnx.purpose }}</td>
            </tr>

            <tr v-if="filteredData.length == 0">
              <td class="text-center" colspan="100%">No Transactions</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="text-center text-gray-500" v-else>
      <p>Please select From & To date to filter</p>
    </div>
  </div>
</template>

<script>
import mixin from '@/utils/mixin.js';
import AppHeader from '@/components/common/Header.vue';
import Loading from '@/components/common/Loading.vue';
import FromToDate from '@/components/common/FromToDate.vue';
import SearchSort from '@/components/common/SearchSort.vue';

export default {
  name: 'ReportTransactions',
  mixins: [ mixin ],
  components: { AppHeader, Loading, FromToDate, SearchSort },
  data() {
    return {
      state: 'idle',
      data: [],
      filteredData: [],
    }
  },

  methods: {
    getData(from, to) {
      this.state = 'loading';

      this.request('GET', 'reports/transactions?from=' + from + '&to=' + to, {}, (resp) => {
        this.state = 'idle';
        if (resp.success) {
          this.data = resp.data;
          this.filteredData = resp.data;
          this.$nextTick(() => {
            this.$refs.search._emit();
          });
        } else alert(resp.message);
      });
    },

    searchUpdated(q, search, sort, order) {
      if (!q ||q == null || q.length == 0) this.filteredData = this.data;

      if (search == '-') this.filteredData = this.data.filter((item) => JSON.stringify(item).toLowerCase().includes(q.toLowerCase()));
      else this.filteredData = this.data.filter((item) => JSON.stringify(this.getDeepValue(item, search)).toLowerCase().includes(q.toLowerCase()));

      this.filteredData.sort((a, b) => {
        let aData = this.getDeepValue(a, sort), bData = this.getDeepValue(b, sort);
        return (aData == bData ? 0 : aData < bData ? -1 : 1) * (order == 'desc' ? -1 : 1);
      });
    },
  },

  created() {
    if (!this.$store.state.api_token) this.$router.push('/');
  }
}
</script>
